import { Holiday, MONTHS } from './types';
import styled from 'styled-components';
import { DaySelectionProps, MonthCalendar } from './MonthCalendar';

export interface YearCalendarProps extends DaySelectionProps {
  holidays: Holiday[];
  year: number;
}

export function YearCalendar({
  year,
  holidays,
  onToggle,
  selected,
}: YearCalendarProps) {
  return (
    <YearWrapper>
      {MONTHS.map((index) => (
        <MonthCalendar
          key={`${year}-${index}`}
          holidays={holidays}
          monthIndex={index}
          onToggle={onToggle}
          selected={selected}
          showName
          size="small"
          year={year}
        />
      ))}
    </YearWrapper>
  );
}

const YearWrapper = styled.div`
  display: grid;
  column-gap: 40px;
  grid-template-columns: calc(7 * 24px + 6 * 12px) calc(7 * 24px + 6 * 12px);
  row-gap: 24px;
`;
